import { makeStyles } from '@fluentui/react-components';

import { palette } from './palette';
import { tokens } from './tokens';

export const useAppButtonStyles = makeStyles({
    primary: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        height: '38px',
        padding: '0 18px',
        backgroundColor: palette.accent,
        color: palette.primaryText,
        border: 'none',
        borderRadius: palette.pillRadius,
        fontSize: '13px',
        fontWeight: tokens.fontWeightSemibold,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        cursor: 'pointer',
        boxShadow: palette.softShadowSm,
        transition: 'background-color 160ms ease, box-shadow 160ms ease',
        '&:hover:not(:disabled)': {
            backgroundColor: palette.accentHover,
            color: palette.primaryText,
            boxShadow: palette.softShadowMd,
        },
        '&:disabled': {
            opacity: 0.4,
            cursor: 'not-allowed',
        },
    },
    secondary: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        height: '38px',
        padding: `0 18px`,
        backgroundColor: palette.panelBg,
        color: tokens.colorNeutralForeground1,
        border: `1px solid ${palette.cardBorder}`,
        borderRadius: palette.pillRadius,
        fontSize: '13px',
        fontWeight: tokens.fontWeightSemibold,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        cursor: 'pointer',
        transition: 'background-color 160ms ease, border-color 160ms ease',
        '&:hover:not(:disabled)': {
            backgroundColor: palette.panelMuted,
            border: `1px solid ${palette.outlineGray}`,
        },
        '&:disabled': {
            opacity: 0.4,
            cursor: 'not-allowed',
        },
    },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        height: '32px',
        padding: '0 4px',
        border: 'none',
        background: 'transparent',
        color: palette.accentText,
        fontSize: '14px',
        fontWeight: tokens.fontWeightSemibold,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        cursor: 'pointer',
        borderRadius: tokens.borderRadiusMedium,
        '& svg': { width: '18px', height: '18px', transition: 'transform 160ms ease' },
        '&:hover:not(:disabled) svg': { transform: 'translateX(2px)' },
        '&:focus-visible': { outline: `2px solid ${palette.accent}`, outlineOffset: '2px' },
        '&:disabled': { opacity: 0.4, cursor: 'not-allowed' },
    },
});
